import { SOCIAL_PROFILES } from '../../../lib/structuredData';

/**
 * The redesigned footer's navigation in two groups, each under a small label (upgrade brief
 * §2.1): `{ key, label, links: [{ to, label }] }`. "For guests" holds what a guest uses
 * (local deals, their codes, how it works from the guest tab, the story); "For businesses &
 * venues" the advertiser and venue pages (the two audience pages, pricing, the placement
 * directory, the free listing, the venue application). Production paths; the package's
 * "Log in on Tappd ↗" link is a real "Sign in" button (SiteFooter, signed out only).
 */
export const SITE_FOOTER_GROUPS = [
  {
    key: 'guests',
    label: 'For guests',
    links: [
      { to: '/local-deals-near-me', label: 'Local deals' },
      { to: '/deal-wallet', label: 'Deal wallet' },
      { to: '/how-it-works#patrons', label: 'How it works' },
      { to: '/our-story', label: 'Our story' },
    ],
  },
  {
    key: 'business',
    label: 'For businesses & venues',
    links: [
      { to: '/for-businesses', label: 'Businesses' },
      { to: '/for-venues', label: 'Venues' },
      { to: '/pricing', label: 'Pricing' },
      { to: '/venues', label: 'Find a placement' },
      { to: '/free-listing', label: 'Free listing' },
      { to: '/venue/apply', label: 'Get free coasters' },
    ],
  },
];

/** Every footer nav link, in document order (SITE_FOOTER_GROUPS flattened). */
export const SITE_FOOTER_LINKS = SITE_FOOTER_GROUPS.flatMap((group) => group.links);

/** The service-area line under the footer logo. */
export const SITE_FOOTER_SERVICE_AREA = 'Starting in Medford, NJ · Serving South Jersey';

/**
 * The legal links of the bottom row. The package's preview-only items ("Design preview ·
 * September 2026", "Brand guide", "All pages") are not part of the production footer.
 */
export const SITE_FOOTER_LEGAL = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

/** The contact address of the handwritten mailto note. */
export const SITE_FOOTER_EMAIL = 'hello@tappd.app';

const SOCIAL_NAMES = [
  [/instagram\.com/i, 'instagram', 'Instagram'],
  [/facebook\.com/i, 'facebook', 'Facebook'],
];

/**
 * The footer's social links: exactly the Organization JSON-LD `sameAs` list
 * (lib/structuredData SOCIAL_PROFILES), so the two can never drift apart
 * (phase5d.seo.qa pins it). `{ href, id, name }`; `id` picks the icon.
 */
export const SITE_FOOTER_SOCIAL = SOCIAL_PROFILES.map((href) => {
  const match = SOCIAL_NAMES.find(([re]) => re.test(href));
  return { href, id: match ? match[1] : 'link', name: match ? match[2] : new URL(href).hostname };
});
